import { render, staticRenderFns } from "./popup-customer-follow-up-add.vue?vue&type=template&id=203ea888&scoped=true"
import script from "./popup-customer-follow-up-add.vue?vue&type=script&lang=js"
export * from "./popup-customer-follow-up-add.vue?vue&type=script&lang=js"
import style0 from "./popup-customer-follow-up-add.vue?vue&type=style&index=0&id=203ea888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ea888",
  null
  
)

export default component.exports